document.addEventListener('click', function (event) {
  const element = event.target.closest('.custom_image_link');

  if (!element) return;

  const link = element.getAttribute('href');

  if (link) {
    event.preventDefault();
    window.location.href = link;
  }
});

const observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    if (
      mutation.type === 'attributes' &&
      mutation.attributeName === 'aria-label' &&
      mutation.target.classList.contains('custom_image_link')
    ) {
      mutation.target.removeAttribute('aria-label');
    }
  });
});

observer.observe(document.body, {
  attributes: true,
  subtree: true,
  attributeFilter: ['aria-label']
});

(function () {
  function setupCookieConsent() {
    const cookieConsent = document.querySelector('csm-cookie-consent');

    if (!cookieConsent || !cookieConsent.shadowRoot) {
      return false;
    }

    const shadowRoot = cookieConsent.shadowRoot;

    function removeCsmWrapper() {
      const wrapper = shadowRoot.querySelector('#csm-wrapper');

      if (wrapper) {
        wrapper.removeAttribute('id');
      }
    }

    removeCsmWrapper();

    const shadowObserver = new MutationObserver(function () {
      removeCsmWrapper();
    });

    shadowObserver.observe(shadowRoot, {
      childList: true,
      subtree: true
    });

    return true;
  }

  if (setupCookieConsent()) {
    return;
  }

  const documentObserver = new MutationObserver(function () {
    if (setupCookieConsent()) {
      documentObserver.disconnect();
    }
  });

  documentObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();





(function () {
  function protectAnnouncementBar() {
    var announcementBar = document.querySelector('.announcement-bar');

    if (!announcementBar) {
      return;
    }

    announcementBar.setAttribute('role', 'region');

    if (announcementBar.dataset.roleObserver) {
      return;
    }

    announcementBar.dataset.roleObserver = 'true';

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'role' &&
          announcementBar.getAttribute('role') !== 'region'
        ) {
          announcementBar.setAttribute('role', 'region');
        }
      });
    });

    observer.observe(announcementBar, {
      attributes: true,
      attributeFilter: ['role']
    });
  }

  protectAnnouncementBar();

  var bodyObserver = new MutationObserver(function () {
    protectAnnouncementBar();
  });

  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

(function () {
  function removeAcaAttributes() {
    var containers = document.querySelectorAll(
      '#aca-banners-wrapper .aca-banner-container'
    );

    containers.forEach(function (container) {
      if (container.hasAttribute('aria-live')) {
        container.removeAttribute('aria-live');
      }

      if (container.hasAttribute('aria-label')) {
        container.removeAttribute('aria-label');
      }
    });
  }

  // Check existing elements
  removeAcaAttributes();

  // Watch for the app adding/replacing the banner
  var observer = new MutationObserver(function () {
    removeAcaAttributes();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-live', 'aria-label']
  });
})();
(function () {
  function removeFooterInput() {
    document
      .querySelectorAll('input[aria-label="ftr-tmp-input"]')
      .forEach(function (input) {
        input.remove();
      });
  }

  // Remove it if it already exists
  removeFooterInput();

  // Remove it immediately when the app adds it
  var observer = new MutationObserver(function () {
    removeFooterInput();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();


(function () {
  function fixAcaPopup() {
    var popup = document.querySelector('.aca-main-wrapper');
    var mainContent = document.querySelector('#MainContent');

    if (!popup || !mainContent) {
      return;
    }

    /*
     * Move the app popup inside the main content landmark.
     */
    if (!mainContent.contains(popup)) {
      mainContent.appendChild(popup);
    }

    /*
     * Give the popup appropriate dialog semantics.
     */
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');

    /*
     * Give the dialog an accessible name if one does not already exist.
     */
    if (
      !popup.hasAttribute('aria-label') &&
      !popup.hasAttribute('aria-labelledby')
    ) {
      popup.setAttribute('aria-label', 'Free Gift with Purchase');
    }
  }

  /*
   * Run immediately if the app has already loaded.
   */
  fixAcaPopup();

  /*
   * Watch for the app creating the popup.
   */
  var observer = new MutationObserver(function () {
    fixAcaPopup();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();